import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export const fiscalCashregisterHeader = [
    { field: 'id', headerName: '#', width: 25, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'companyName', headerName: 'Emri klientit', width: 240, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'idnumber', headerName: 'Numri Identifikues', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'posName', headerName: 'Arka', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'location', headerName: 'Lokacioni', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'description', headerName: 'Përshkrimi', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    // { field: 'isActive', headerName: 'Statusi', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'isActive',
        headerName: 'Statusi',
        width: 70,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => (
            params.value ? <CheckCircleOutlineIcon style={{ color: "green" }} /> : ""
        )
    },
    { field: 'registrationDate', headerName: 'Data regjistrimit', width: 140, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'fiscalYear', headerName: 'Viti fiskal', width: 76, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },

]

export default fiscalCashregisterHeader